enum ZoeRoute {
  Home = '/',
  Dashboard = '/dashboard',
  Applications = '/applications',
  PublishedManifests = '/published-manifests',
  Jobs = '/jobs',
  Resources = '/resources',
  Data = '/data',
  Help = '/help',
  Workflow = '/workflow',
  DpState = '/my-data',
  Usage = '/usage',
  Documentation = '/documentation',
  FileExplorer = '/file-explorer',
  Peer = '/peer',
  Instances = '/instances',
  Notifications = '/notifications',
  Monitoring = '/monitoring',
  CancelUserResourcesDeletion = '/cancel-user-resources-deletion',
  RawFeedData = '/raw-feed-data',
  GlobalSearchResult = '/global-search',
  SpringboardBrowser = '/springboard-browser',
  SupersetVisualisations = '/visualisations-app',
  AdministrationCentre = '/administration-centre',
  AuthorizeDevice = '/authorize/device',
}

export enum MyRoute {
  FileExplorer = '/fileExchange',
  Instances = '/workbench',
}

export default ZoeRoute;
